import { useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/features/coaching/advisorLandingPage/TopCoachesSection/TopCoachesSection.styl'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { topAdvisorsGuards } from 'components/features/coaching/advisorStore/guards/advisorsLandingGuards'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { topAdvisorsSelector } from 'components/features/coaching/advisorStore/selectors/landingPage'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { COACH_PAGE } from 'constants/pages'
import { CoachCard } from 'components/features/coaching/advisorLandingPage/CoachCard/CoachCard'

const TopCoachesSection = () => {
  const isLoaded = useSimpleGuard(topAdvisorsGuards, {}, 'TopCoachesSection')
  const advisors = useStoreSelector(topAdvisorsSelector)

  const advisorsChild = useMemo(() => {
    if (!advisors) {
      return null
    }

    return advisors.map((advisor) => (
      <NavigationLink className={ styles.coach } to={{ anchor: COACH_PAGE, id: advisor.username }} key={ advisor.uid }>
        <CoachCard
          key={ name as string | number | undefined }
          advisor={ advisor }
        />
      </NavigationLink>
    ))
  }, [advisors])

  return (
    <section className={ cn(styles.topCoachesSection) }>
      { !isLoaded && (
        <LoadingOverlay className={ styles.preloader } />
      )}
      <h2 className={ styles.header }>
        MEET OUR TOP COACHES
      </h2>
      { advisorsChild && (
        <div className={ styles.coaches }>
          { advisorsChild }
        </div>
      )}
    </section>
  )
}

export default TopCoachesSection
